import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AutoComplete, RaisedButton, TableRow, TableRowColumn } from 'material-ui';

import styles from 'styles';
import { useRefState } from 'helpers/react.utils';
import api from 'services';
import AwaitableBtn from 'components/Base/AwaitableBtn';

import { addNotification } from 'actions/notifications/notifications';

function CompaniesRealNamesRow({ key, company, addNotification, realCompaniesIds }) {
    const [search, setSearch, searchRef] = useRefState('');
    const [companies, setCompanies] = useState([]);
    const [selectedCompany , setSelectedCompany] = useState(null);
    const [realCompany, setRealCompany] = useState(company.realCompany || null);
    const [shouldShowUpdate, setShouldShowUpdate] = useState(false);
    const [shouldShowDelete, setShouldShowDelete] = useState(!!realCompany);

    const searchCompanies = async searchText => {
        setSearch(searchText);

        if (searchText.length < 2) {
            return;
        }

        const companies = await api.findRealCompany('ifchor', searchText);

        if (searchRef.current !== searchText) {
            return;
        }

        if (companies.status === 200) {
            setCompanies(companies.data.data);
        }
    }

    const onCompanySelected = company => {
        setSelectedCompany(company);
        setShouldShowUpdate(true);
    }

    const handleUpdateCompany = async (parentCompany, selectedCompany) => {
        if (!parentCompany || !selectedCompany) {
            return;
        }
        
        const response = await api.saveRealCompany(parentCompany._id, selectedCompany._id);

        if (response.status === 200) {
            if (response.errors && response.errors.length) {
                addNotification({
                    title: "Error",
                    message: response.errors[0].message || response.errors[0].messages[0],
                    level: "error",
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
            } else {
                addNotification({
                    title: "Success",
                    message: "Real name updated successfully",
                    level: "success",
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
                setShouldShowUpdate(false);
                setShouldShowDelete(true);
            }
        }
    }

    const handleDeleteRealCompany = async ({ _id, realCompany: realCompanyFromDb }) => {
        let realCompanyId;
        if (!realCompanyFromDb) {
            realCompanyId = selectedCompany._id
        } else {
            realCompanyId = realCompanyFromDb.company._id;
        }
        
        if (!_id || !realCompanyId) {
            return;
        }

        const response = await api.deleteRealCompany(_id, realCompanyId);

        if (response.status === 200) {
            if (response.errors && response.errors.length) {
                addNotification({
                    title: "Error",
                    message: response.errors[0].message || response.errors[0].messages[0],
                    level: "error",
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
            } else {
                addNotification({
                    title: "Success",
                    message: "Real name removed successfully",
                    level: "success",
                    _id: new Date().getMilliseconds(),
                    autoDismiss: 3,
                });
                setShouldShowDelete(false);
                setRealCompany(null);
                setSearch('');
            }
        }
    }

    return (
        <TableRow
            key={key}
        >
            <TableRowColumn 
                style={styles.tableRowColumnCSS}
                className='cargo-realnames_name_column'
            >
                {company.name}
            </TableRowColumn>

            <TableRowColumn>
                {
                    realCompaniesIds.includes(company._id) && <b>IFCHOR</b>
                }
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                <AutoComplete
                    name="companyName"
                    textFieldStyle={{ fontSize: "13px" }}
                    hintText="Company name"
                    searchText={search || (realCompany && realCompany.company.name) || ''}
                    dataSource={companies}
                    dataSourceConfig={{ text: "name", value: "item" }}
                    onUpdateInput={searchCompanies}
                    onNewRequest={onCompanySelected}
                    filter={AutoComplete.noFilter}
                    listStyle={{ overflow: "auto", maxHeight: "300px" }}
                    popoverProps={{
                        canAutoPosition: true,
                    }}
                />
            </TableRowColumn>

            <TableRowColumn style={styles.tableRowColumnCSS}>
                <div className={shouldShowUpdate ? '' : 'hidden'} style={{ textAlign: 'center' }}>
                    <AwaitableBtn>
                        <RaisedButton
                            label='Update'
                            primary
                            onClick={() => handleUpdateCompany(company, selectedCompany)}
                        />
                    </AwaitableBtn>
                </div>
                <div className={shouldShowDelete ? '' : 'hidden'} style={{ textAlign: 'center' }}>
                    <AwaitableBtn>
                        <RaisedButton 
                            label='Clear'
                            secondary
                            onClick={() => handleDeleteRealCompany(company)}
                        />
                    </AwaitableBtn>
                </div>
            </TableRowColumn>
        </TableRow>
    );
}

export default connect(
    (state) => {
        return {
            realCompaniesIds: state.realCompanies.items.map(c => c._id),
        }
    },
    dispatch => bindActionCreators({
        addNotification,
    },
    dispatch),
)(CompaniesRealNamesRow);



// WEBPACK FOOTER //
// ./app/components/Companies/CompanyRealName/CompaniesRealNamesRow.jsx